/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Order_Summary_CalculatedInputs */

const en_admin_external_booking_edit_order_summary_calculated = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CalculatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculated`)
};

const de_admin_external_booking_edit_order_summary_calculated = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CalculatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechnet`)
};

const es_admin_external_booking_edit_order_summary_calculated = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CalculatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculado`)
};

const fr_admin_external_booking_edit_order_summary_calculated = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CalculatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculé`)
};

const nl_admin_external_booking_edit_order_summary_calculated = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CalculatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berekend`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CalculatedInputs) => LocalizedString} */
const it_admin_external_booking_edit_order_summary_calculated = en_admin_external_booking_edit_order_summary_calculated;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CalculatedInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_order_summary_calculated = en_admin_external_booking_edit_order_summary_calculated;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CalculatedInputs) => LocalizedString} */
const pl_admin_external_booking_edit_order_summary_calculated = en_admin_external_booking_edit_order_summary_calculated;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CalculatedInputs) => LocalizedString} */
const hu_admin_external_booking_edit_order_summary_calculated = en_admin_external_booking_edit_order_summary_calculated;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CalculatedInputs) => LocalizedString} */
const ro_admin_external_booking_edit_order_summary_calculated = en_admin_external_booking_edit_order_summary_calculated;

/**
* | output |
* | --- |
* | "Calculated" |
*
* @param {Admin_External_Booking_Edit_Order_Summary_CalculatedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_order_summary_calculated = /** @type {((inputs?: Admin_External_Booking_Edit_Order_Summary_CalculatedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Order_Summary_CalculatedInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_order_summary_calculated(inputs)
	if (locale === "de") return de_admin_external_booking_edit_order_summary_calculated(inputs)
	if (locale === "es") return es_admin_external_booking_edit_order_summary_calculated(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_order_summary_calculated(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_order_summary_calculated(inputs)
	if (locale === "it") return it_admin_external_booking_edit_order_summary_calculated(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_order_summary_calculated(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_order_summary_calculated(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_order_summary_calculated(inputs)
	return ro_admin_external_booking_edit_order_summary_calculated(inputs)
});
export { admin_external_booking_edit_order_summary_calculated as "admin.external_booking_edit.order_summary.calculated" }